import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import RulesView from "../views/RulesView.vue";
import atm9Rules from "../views/atm9Rules.vue";
import NotFoundView from "@/views/NotFoundView.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/rules",
    name: "rules",
    component: RulesView,
  },
  {
    path: "/rules/atm9",
    name: "atm9Rules",
    component: atm9Rules,
  },
  {
    path: "*",
    name: "not-found",
    component: NotFoundView,
  },


];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
